//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Icon from "@Shared/components/general/fa-icon.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CalendarEventInformation",
  components: {
    Icon
  },
  props: {
    eventDetails: {
      type: Object,
      default: () => ({})
    },
    startTime: {
      type: Date,
      required: true
    },
    endTime: {
      type: Date,
      required: true
    }
  },
  computed: {
    eventInfo() {
      if (Array.isArray(this.eventDetails.events)) return this.eventDetails.events[0];
      return this.eventDetails || {};
    },
    eventParticipants() {
      var _this$eventInfo$parti, _this$eventInfo$parti2;
      if (Array.isArray((_this$eventInfo$parti = this.eventInfo.participants) == null ? void 0 : _this$eventInfo$parti.participants)) return (_this$eventInfo$parti2 = this.eventInfo.participants) == null ? void 0 : _this$eventInfo$parti2.participants;
      return this.eventInfo.participants || [];
    }
  },
  methods: {
    participantName(participant) {
      return participant.name || participant.email;
    }
  }
});